import { Component } from 'react';
import type { ErrorInfo, PropsWithChildren, ReactNode } from 'react';

interface State {
  readonly error: Error | null;
}

interface Props extends PropsWithChildren {
  readonly fallback?: (error: Error, reset: () => void) => ReactNode;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, info);
  }

  private reset = () => this.setState({ error: null });

  override render(): ReactNode {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);
      return (
        <div role="alert" style={{ padding: 24, fontFamily: 'sans-serif' }}>
          <h1>Something went wrong.</h1>
          <p>{this.state.error.message}</p>
          <button type="button" onClick={this.reset}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
